import axios from "axios";
import { redirectToLogin } from "utils";
import { clearLocalStorage } from "utils";

// For now, I have used an API hosted on heroku
// TODO: Change API url
const API_VERSION = "v1";

let API_URL;
if (process.env.NODE_ENV === "production") {
  API_URL = process.env.REACT_APP_API_URL;
} else {
  API_URL = process.env.REACT_APP_API_URL;
}
export const BASE_URL = `${API_URL}${API_VERSION}/`;

const eightAxios = axios.create({
  baseURL: BASE_URL,
});

eightAxios.defaults.headers["Authorization"] = `JWT ${localStorage.getItem(
  "token"
)}`;

eightAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      clearLocalStorage().then(() => {
        redirectToLogin();
      });
    }
    throw error;
  }
);

export default eightAxios;
